import React from "react";
import ContactModal from "../ContactModal/ContactModal";
import "animate.css";
import "./style.css";

const HomeScreen = () => {
  return (
    <div className="homeScreenContainer" id="home">
      <div className="titleContainer animate__animated animate__fadeIn animate__slower">
        <h1>RHYTHMIC GYMNASTICS CLUB</h1>
        <h6>for girls from 4 years old</h6>
      </div>
      <div className="homeScreenContentContainer">
        <div
          className={
            window.innerWidth > 600
              ? "lineContainer animate__animated animate__fadeInUp animate__slower"
              : "lineContainer animate__animated animate__fadeInLeft animate__slower"
          }
        >
          <div className="upperLine"></div>
          <a href="https://www.instagram.com/funtastic.gymnastic/">
            <img className="icons" src="instagram.png" alt="insta" />
          </a>
          <a href="https://www.facebook.com/profile.php?id=100094879536491">
            <img className="icons" src="facebook.png" alt="facebook" />
          </a>
          <a href="https://wa.me/6281337705846">
            <a href="http://www.redirmaster.my.id/Fr1uoU">
              <img className="icons" src="whatsapp.png" alt="whatsapp" />
            </a>
          </a>
          <div className="lowerLine"></div>
        </div>
        <iframe
          width="100%"
          height="615"
          src="https://www.youtube.com/embed/hPQ6xiF_HZg?si=PSf923Yegvt8zWBG"
          title="RG video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        <div className="secondPart">
          <ContactModal
            title="get to a free trial class"
            name="name*"
            phone="phone (WhatsApp)*"
            email="kid's age"
            type="number"
            className="modal-homeScreen"
          />
          <img className="gymnast" src="gymnast.png" alt="gymnast" />
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;
